import React, { useCallback } from 'react';
import useDevice, { DEVICE_MOBILE } from 'hooks/use-device';
import { Link } from 'react-router-dom';
import { LogoutIcon } from 'icons';
import Button from 'componets/button';
import { useHistory } from 'react-router-dom';
import styles from './index.module.scss';
import logo from 'images/logo_autopass_for_business.svg';
import logo_white from 'images/logo_autopass_for_business_white.svg';
import logoMobile from 'images/logo_autopass_for_business_mobile.svg';
import { mapsUrl } from 'config/config';
import { PATH } from 'config/path';
import analytics from 'service/analytics';
import { clearStorage } from 'service/local-data-provider';

const Logo = ({ isLogin, theme }) => {
  const device = useDevice();
  const isMobile = device === DEVICE_MOBILE;

  const defaultLogo = isMobile ? logoMobile : logo;

  if (isLogin) {
    return (
      <Link to={PATH.PROFILE}>
        <img src={theme === 'black' ? logo_white : defaultLogo} alt="企業方案" />
      </Link>
    );
  }

  return <img src={theme === 'black' ? logo_white : defaultLogo} alt="企業方案" />;
};

const Navbar = ({ theme, isLogin = true }) => {
  const history = useHistory();

  const handleLogout = useCallback(() => {
    clearStorage();
    analytics.topBarLogoutButtonClick();
    history.push(PATH.LOGIN);
  }, [history]);

  return (
    <nav>
      <div className={styles.container}>
        <div className={styles.logo}>
          <Logo theme={theme} isLogin={isLogin} />
        </div>
        {isLogin && (
          <div className={styles['nav-button-container']}>
            <Button
              className={styles['support-button']}
              variant="outline"
              onClick={() => {
                analytics.track('支援場站_click');
                window.open(mapsUrl);
              }}
            >
              支援場站
            </Button>
            <Button
              leftIcon={<LogoutIcon width={20} height={20} />}
              className={styles['support-button']}
              variant="outline"
              onClick={handleLogout}
            >
              登出
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
